import { render } from "./IntegrateWithText.vue?vue&type=template&id=1cb30f76&scoped=true"
import script from "./IntegrateWithText.vue?vue&type=script&lang=js"
export * from "./IntegrateWithText.vue?vue&type=script&lang=js"

import "./IntegrateWithText.vue?vue&type=style&index=0&id=1cb30f76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb30f76"],['__file',"src/Components/ChatWidget/IntegrateWithText/IntegrateWithText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cb30f76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cb30f76', __exports__)) {
    api.reload('1cb30f76', __exports__)
  }
  
  module.hot.accept("./IntegrateWithText.vue?vue&type=template&id=1cb30f76&scoped=true", () => {
    api.rerender('1cb30f76', render)
  })

}


export default __exports__